import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ContactInquiryRequest, ContactInquiryResponse, ContactInquiriesPage } from '../models/contact.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/ContactInquiries`;

  submitInquiry(data: ContactInquiryRequest): Observable<ContactInquiryResponse> {
    console.log('Sending Contact Inquiry:', data);
    return this.http.post<ContactInquiryResponse>(this.apiUrl, data);
  }

  getInquiries(pageNumber: number = 1, pageSize: number = 10): Observable<ContactInquiriesPage> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());

    return this.http.get<ContactInquiriesPage>(this.apiUrl, { params });
  }

  getInquiryById(id: number): Observable<ContactInquiryResponse> {
    return this.http.get<ContactInquiryResponse>(`${this.apiUrl}/${id}`);
  }
}
